module.exports = __webpack_public_path__ + "img/arrow-square-down.f8615192.svg";